@if (application(); as application) {
  <div class="application-details">
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
      </app-decision-data-preview>
      <br>
    </ng-container>
    <app-applicant-preview
      [application]="application"
      [expanded]="expanded">
    </app-applicant-preview>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <app-application-data-preview [application]="application">
    </app-application-data-preview>
    <br>
    <h3>
      Przedmiot deklaracji
    </h3>
    <dl class="mb-4">
      <dt class="mb-3">
        <strong>Informacje podstawowe</strong>
      </dt>
      <dd>
        <div class="row">
          <div class="col-12">
            <app-label
              label="Deklaracja dotyczy:">
              {{ application?.propertyType || '-' }}
            </app-label>
          </div>
          <div class="col-12">
            <app-label label="Okoliczności powodujące obowiązek złożenia deklaracji:">
              {{ application?.submissionPurpose || '-' }}
            </app-label>
          </div>
          <div class="col-12">
            <app-label label="Data od:">
              {{ application?.startDate | date }}
            </app-label>
          </div>
          <div class="col-12">
            <app-label label="Rodzaj podmiotu:">
              {{ application?.entityKind || '-' }}
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <dl class="mb-4">
      <dt class="mb-3">
        <strong>Adres nieruchomości, na której powstają odpady komunalne</strong>
      </dt>
      <dd>
        <div class="row">
          <div class="col-md-4">
            <app-label label="Numer działki:">
              {{ application?.registrationNumber || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Miejscowość:">
              {{ application?.city || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Ulica:">
              {{ application?.street || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Nr Domu:">
              {{ application?.houseNumber || '-' }}
            </app-label>
            @if (application?.apartmentNumber; as apartmentNumber) {
              &nbsp;
              <app-label label="Nr mieszkania:">
                {{ apartmentNumber || '-' }}
              </app-label>
            }
          </div>
          <div class="col-md-4">
            <app-label label="Liczba lokali mieszkalnych:">
              {{ application?.identicalBuildingsCount || '-' }}
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <dl class="mb-4">
      <dt class="mb-3">
        <strong>Podstawa wyliczenia opłaty</strong>
      </dt>
      <dd>
        <div class="row">
          <div class="col-md-3">
            <app-label label="Liczba osób zamieszkujących:">
              {{ application?.numberOfResidents || '-' }}
            </app-label>
          </div>
          <div class="col-md-3">
            <app-label label="Stawka:">
              {{ application?.feeRate | currency }}
            </app-label>
          </div>
          <div class="col-md-3">
            <app-label label="Kwota opłaty:">
              {{ application?.feeAmount | currency }}
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <dl class="mb-4">
      <dt class="mb-3">
        <strong>Oświadczenie o kompostowaniu bioodpadów</strong>
      </dt>
      <dd>
        <div class="row">
          <div class="col-12">
            <app-label
              label="Oświadczam, że na nieruchomości wskazanej w D.5. POSIADAM KOMPOSTOWNIK PRZYDOMOWY i kompostuję w nim bioodpady w związku z tym chcę skorzystać z częściowego zwolnienia w opłacie:">
              {{ application?.propertyHasComposter ? 'Tak' : 'Nie' }}
            </app-label>
          </div>
          @if (application?.propertyHasComposter) {
            <div class="col-md-3">
              <app-label label="Liczba osób uprawniona do zwolnienia:">
                {{ application?.numberOfResidentsForBioExemption || '-' }}
              </app-label>
            </div>
            <div class="col-md-3">
              <app-label label="Stawka zwolnienia:">
                {{ application?.bioExemptionRate | currency }}
              </app-label>
            </div>
            <div class="col-md-3">
              <app-label label=" Kwota zwolnienia:">
                {{ application?.bioExemptionAmount | currency }}
              </app-label>
            </div>
          }
        </div>
      </dd>
    </dl>
    <dl class="mb-4">
      <dt class="mb-3">
        <strong>Zwolnienie z tytułu rodziny wielodzietnej w rozumieniu ustawy o Karcie Dużej Rodziny lub z tytułu
          kryterium dochodowego</strong>
      </dt>
      <dd>
        <div class="row">
          <div class="col-12">
            <app-label
              label="Rodzaj częściowego zwolnienia:">
              {{ application?.partialTypeExemption || '-' }}
            </app-label>
          </div>
          <div class="col-12">
            <app-label
              label="Liczba osób uprawniona do zwolnienia:">
              {{ application?.numberOfResidentsForExemption || '0' }}
            </app-label>
          </div>
          <div class="col-12">
            <app-label
              label="Kwota częściowego zwolnienia z opłaty:">
              {{ application?.exemptionAmountRate | currency }}
            </app-label>
          </div>
          <div class="col-12">
            <app-label
              label="Wysokość częściowego zwolnienia z opłaty:">
              {{ application?.exemptionAmount | currency }}
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <div class="row">
      <div class="col-12">
        <app-label label="Wysokość miesiecznej opłaty po uwzględnieniu zwolnień:">
          {{ application?.totalMonthlyFeeAmount | currency }}
        </app-label>
      </div>
    </div>
    <br>
    <dl class="mb-4">
      <dt class="mb-3">
        <strong>Dla rodzin wielodzietnych które posiadają kartę dużej rodziny</strong>
      </dt>
      <dd>
        <div class="row">
          <div class="col-12">
            <app-label label="Posiadam Kartę Dużej Rodziny fizycznie:">
              {{ application?.forestHasLandRegister ? 'Tak' : 'Nie' }}
            </app-label>
          </div>
          @if (!application?.forestHasLandRegister) {
            <div class="col-md-4">
              <app-label
                label="Liczba rodzin wielodzietnych:">
                {{ application?.largeFamiliesCount || '-' }}
              </app-label>
            </div>
            <div class="col-12">
              <app-label
                label="Łączna liczba osób w rodzinie(-nach) wielodzietnej(-nych):">
                {{ application?.largeFamiliesTotalPersonsCount || '0' }}
              </app-label>
            </div>
          }
        </div>
      </dd>
    </dl>
    @if (application?.forestHasLandRegister) {
      <dl class="mb-4">
        <dt class="mb-3">
          <strong>Posiadacze karty dużej rodziny</strong>
        </dt>
        <dd>
          <app-large-family-cards-preview [cards]="application?.largeFamilyCards || []">
          </app-large-family-cards-preview>
        </dd>
      </dl>
    }
    <br>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]="application">
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]="application">
    </app-attachments-data-preview>
  </div>
}
